import { type SxProps, type Theme, alpha } from "@mui/material/styles";

export const useStyles = () => ({
  alert: {
    mt: 2,
    borderColor: "warning.main",
    // Light orange tint of the (orange) border colour.
    backgroundColor: (theme: Theme) => alpha(theme.palette.warning.main, 0.12),
  } satisfies SxProps<Theme>,
  header: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1,
  } satisfies SxProps<Theme>,
  icon: {
    // Nudge the icon down so it lines up with the title text it sits next to.
    mt: 0.25,
  } satisfies SxProps<Theme>,
  table: {
    mt: 1,
    backgroundColor: "background.paper",
    borderRadius: 1,
    // Clip the rounded corners so the gray header background follows the radius.
    overflow: "hidden",
  } satisfies SxProps<Theme>,
  tableHead: {
    backgroundColor: "grey.100",
  } satisfies SxProps<Theme>,
  tableElement: {
    width: "100%",
    // Fixed layout so the per-column widths are honoured and the address column (no width) fills
    // the remaining space, stretching the table to the full width of the alert.
    tableLayout: "fixed",
  } satisfies SxProps<Theme>,
  rowLink: {
    // Positioning context for the stretched overlay link below.
    position: "relative",
    cursor: "pointer",
  } satisfies SxProps<Theme>,
  rowOverlayLink: {
    // A single real link stretched over the whole row: the entire row is clickable and it is a
    // genuine anchor (keyboard accessible, opens reliably in a new tab, supports middle-click).
    position: "absolute",
    inset: 0,
    zIndex: 1,
  } satisfies SxProps<Theme>,
});
